import React, { useRef, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { fetchResetPassword } from '../../../redux/action/account/password-reset'
import { useDispatch } from 'react-redux'
import { fetchCsrfCookie } from '../../../redux/action/csrf/csrf-cookie'
import SimpleReactValidator from 'simple-react-validator'
import {IoCloseCircleOutline} from 'react-icons/io5'

const PasswordReset = () => {
    const [btnLoading, setBtnLoading] = useState(false)
    const [forceUpdate, setForceUpdate] = useState(0)
    const [currentPassword, setCurrentPassword] = useState('')
    const [password, setPassword] = useState('')
    const [passwordConfirmation, setPasswordConfirmation] = useState('')
    const [confirmLogo, setConfirmLogo] = useState(false)
    const [typingTimeout, setTypingTimeout] = useState(0)

    const dispatch = useDispatch()
    const {t} = useTranslation();

    const validator = useRef(new SimpleReactValidator({
        messages: {
          required:"پر کردن این فیلد الزامی است",
          min: " تعداد کاراکترهای ورودی کم است " 
        },
    }))

    const handleCurrentPassword = (e) => { setCurrentPassword(e.target.value)}

    const handlePassword = event => {
        setPassword(event.target.value)
        if (typingTimeout) { 
            clearTimeout(typingTimeout) 
        }
        setTypingTimeout(setTimeout(function () {
            if(passwordConfirmation !== event.target.value ) {
                setConfirmLogo(true)
            } else {
                setConfirmLogo(false)
            }
        }, 1000))
    }

    const handlePasswordConfirmation = event => {
        setPasswordConfirmation(event.target.value)
        if (typingTimeout) { 
            clearTimeout(typingTimeout) 
        }
        setTypingTimeout(setTimeout(function () {
            if(password !== event.target.value ) {
                setConfirmLogo(true)
            } else {
                setConfirmLogo(false)
            }
        }, 1000))
    }


    const handlePassChange = (e) => {
        e.preventDefault()
        setBtnLoading(true)
        if (validator.current.allValid()) {
            setBtnLoading(false)
            let data = {
                current_password: currentPassword,
                password: password,
                password_confirmation: passwordConfirmation
            }
            if( currentPassword === '' || password === '' || passwordConfirmation === '' ) {
                toast.dismiss()
                toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})
            } else if (password.length < 8 ) {
                toast.dismiss()
                toast.error(t("toast_password_must_have_atleast_8_characters") , {position: 'bottom-right',className: 'foo-bar'})
            } else if (password !== passwordConfirmation) {
                toast.dismiss()
                toast.error(t("toast_repeat_password_does_not_match") , {position: 'bottom-right',className: 'foo-bar'})
            } else {
                dispatch(fetchCsrfCookie())
                dispatch(fetchResetPassword(data))
            }
        } else {
            toast.dismiss()
            setBtnLoading(false)
            setForceUpdate(1)
            validator.current.showMessages()
            toast.dismiss()
            toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})
        }
    }

    return (
        <div className='passwordReset'>
            <Form className='col-lg-5' onSubmit={e => handlePassChange(e)}>
                <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Label>{t("current_password")}:</Form.Label>
                    <Form.Control type="password" name="current_password" value={currentPassword} onChange={ e => handleCurrentPassword(e)} />
                    <span className='validator_error'>{validator.current.message('current_password', currentPassword, 'required')}</span>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Label>{t("new_password")}:</Form.Label>
                    <Form.Control type="password" name="password" value={password} onChange={ e => handlePassword(e)} />
                    <span className='validator_error'>{validator.current.message('password', password, 'required|min:8')}</span>
                </Form.Group>

                <Form.Group className="mb-3 confirm_wrapper" controlId="formBasicPassword">
                    <Form.Label>{t("repeat_new_password")}:</Form.Label>
                    <Form.Control type="password" name="password_confirmation" value={passwordConfirmation} onChange={ e => handlePasswordConfirmation(e)} />
                    <span className='validator_error'>{validator.current.message('password_confirmation', passwordConfirmation, 'required|min:8')}</span>
                    {confirmLogo ? <IoCloseCircleOutline title='تکرار رمز عبور مطابقت ندارد' className='pass_validator' /> : "" }
                </Form.Group>

                <Button variant="primary" type="submit" disabled={btnLoading ? true : false} >
                    {t("change_password")}
                </Button>
            </Form>
        </div>
    )
}

export default PasswordReset
